// extracted by mini-css-extract-plugin
export default {"cart":"addToCart_cart__2uqTv"};